/**
 * Events Single Page: Sticky content / info
 *
 * @author Matt Haynes <matthew.haynes@joipolloi.com>
 * @package The University of Sheffield - Performance Venues
 */

const EventsStickInfo = () => {
    const stickyContent = document.getElementById('stickyContent');
    if (!stickyContent) return;

    const right = document.querySelector('.right');
    const rightPaddingTopAndBottom = 80;
    const maxPos = right.offsetHeight - stickyContent.offsetHeight - rightPaddingTopAndBottom;

    window.addEventListener('scroll', () => {
        const distanceFromTop = right.getBoundingClientRect().top;

        let translatePos = 0;
        if (distanceFromTop < 0) {
            if (Math.abs(distanceFromTop) < maxPos) {
                translatePos = Math.abs(distanceFromTop);
            } else {
                translatePos = maxPos;
            }
        }

        stickyContent.style.transform = `translateY(${translatePos}px)`;
    });
};

export default EventsStickInfo;
